import { createSelector } from "reselect";
import { RootState } from "../../types";

const getSearch = ({ search }: RootState) => search;

export const searchSelector = createSelector([getSearch], (search) => search);
